type Point = {
  label: string
  value: number
}

type Props = {
  points: Point[]
}

export function MiniBarChart({ points }: Props) {
  const max = Math.max(...points.map((point) => point.value), 1)

  return (
    <div className="grid grid-cols-7 gap-2">
      {points.map((point) => {
        const height = `${Math.max((point.value / max) * 100, point.value > 0 ? 18 : 6)}%`

        return (
          <div key={point.label} className="flex flex-col items-center gap-2">
            <div className="flex h-28 w-full items-end rounded-2xl bg-slate-100 px-1 py-1">
              <div
                className="w-full rounded-xl bg-brand-600/90 transition hover:bg-brand-700"
                style={{ height }}
                title={`${point.label}: ${point.value}`}
              />
            </div>
            <div className="text-[11px] text-slate-500">{point.label}</div>
          </div>
        )
      })}
    </div>
  )
}
